import React, { useState } from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMic, FiCopy, FiCheck, FiSettings } = FiIcons;

const VoiceAgentsView = () => {
  const [inboundNumber, setInboundNumber] = useState('');
  const [copied, setCopied] = useState(false);

  // Hardcoded as requested
  const webhookUrl = "https://twilio.gyso.au/api/twilio/voice-agent";

  const handleCopy = () => {
    navigator.clipboard.writeText(webhookUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="space-y-6">
      <div className="border-b border-gray-200 pb-4">
        <h2 className="text-2xl font-bold text-gray-900 flex items-center">
          <SafeIcon icon={FiMic} className="mr-3 text-blue-600" />
          Voice Agents
        </h2>
        <p className="mt-2 text-gray-600">
          Configure and monitor AI-powered voice agents that answer your Twilio calls for GYSO Call.
        </p>
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
        <div className="bg-gray-50 px-6 py-4 border-b border-gray-200 flex justify-between items-center">
          <h3 className="text-lg font-medium text-gray-900">GYSO Call – Demo Agent</h3>
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
            Active
          </span>
        </div>
        
        <div className="p-6 space-y-6">
          {/* Webhook Configuration */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Agent Webhook URL
            </label>
            <div className="flex rounded-md shadow-sm">
              <input
                type="text"
                readOnly
                value={webhookUrl}
                className="flex-1 min-w-0 block w-full px-3 py-2 rounded-none rounded-l-md border border-gray-300 bg-gray-50 text-gray-500 sm:text-sm focus:ring-blue-500 focus:border-blue-500"
              />
              <button
                type="button"
                onClick={handleCopy}
                className="inline-flex items-center px-4 py-2 border border-l-0 border-gray-300 rounded-r-md bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                {copied ? (
                  <>
                    <SafeIcon icon={FiCheck} className="mr-2 text-green-500" />
                    Copied
                  </>
                ) : (
                  <>
                    <SafeIcon icon={FiCopy} className="mr-2 text-gray-400" />
                    Copy
                  </>
                )}
              </button>
            </div>
            <p className="mt-2 text-sm text-gray-500">
              Point your Twilio phone number's Voice webhook to the Agent Webhook URL above to send all calls directly to this voice agent.
            </p>
          </div>

          <div className="border-t border-gray-100 pt-6"></div>

          {/* Local Settings */}
          <div className="max-w-md">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Inbound Twilio Number
            </label>
            <div className="flex space-x-2">
              <div className="relative rounded-md shadow-sm flex-1">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <SafeIcon icon={FiSettings} className="text-gray-400" />
                </div>
                <input
                  type="text"
                  value={inboundNumber}
                  onChange={(e) => setInboundNumber(e.target.value)}
                  placeholder="+61 4xx xxx xxx"
                  className="focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md py-2 border"
                />
              </div>
            </div>
            <p className="mt-1 text-xs text-gray-400">
              This number is stored locally for reference only.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VoiceAgentsView;